<template>
  <path pid="0" d="M13 24a3 3 0 002.59-1.5 1 1 0 00-.86-1.5h-3.46a1 1 0 00-.86 1.5A3 3 0 0013 24zM13 2a8 8 0 00-8 8v5a2 2 0 01-2 2 1 1 0 000 2h20a1 1 0 000-2 2 2 0 01-2-2v-5a8 8 0 00-8-8zM6.46 17A3.89 3.89 0 007 15v-5a6 6 0 0112 0v5a3.89 3.89 0 00.54 2z"/>
</template>
